import { Select, MenuItem } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import * as React from "react";
import "./style/GeneralDetailUpdate.css";
import { callApi } from "../../common/api";
import CustomizedSnackbars from "../alert/alert";
import { MyContext } from "../../MyContext";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";

export default function GeneralUpdate() {
  const [inputData, setInputData] = React.useState({
    firstName: "",
    middleName: "",
    lastName: "",
    email: "",
    phone: "",
    apartmentOrStreet: "",
    city: "",
    state: "",
    zipcode: "",
    occupation: "",
    // countryCode: "",
    country: "",
    link: "",
  });

  const [countries, setCountries] = React.useState([]);
  const [phoneValid, setPhoneValid] = React.useState(false)
  const [newData, setNewData] = React.useState({
    name: "",
    address: "",
  });
  const [selected, setselected] = React.useState(1);
  const [formComplete, setFormComplete] = React.useState(false);
  const [snackBarMsg, setSnackBarMsg] = React.useState({
    message: "",
    severity: "success",
    open: false,
  });
  const { text, setText } = React.useContext(MyContext);
  const [mobile, setMobile] = React.useState(inputData.phone);

  const phoneInput = () => {
    const isValid = isValidPhoneNumber(inputData.phone)
    if (!isValid) {
      setSnackBarMsg({
        message: "Please Enter valid phone number",
        severity: "error",
        open: true
      })
      setPhoneValid(false)
      return

    } else {
      setPhoneValid(true)
    }
  }

  const handlePhoneNumberChange = (value) => {
    setMobile(value);
  };

  React.useEffect(() => {

    setInputData((prevState) => ({
      ...prevState,
      phone: mobile,
    }));
  }, [mobile])

  async function handleInputChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    if (e && e.target.name !== 'country' && e.target.name !== "countryCode") {
      if (e.target.hasAttribute('data-numeric')) {
        if (/^[0-9]*$/.test(value) || value === '') {
          setInputData((prevState) => ({
            ...prevState,
            [name]: value,
          }));
        } else {
          setSnackBarMsg({
            message: "This should be a number",
            severity: "warning",
            open: true,
          });
        }
      } else {
        if (name !== "apartmentOrStreet" && name !== "link") {
          if (value !== "" && !/^[A-Za-z]+$/.test(value)) {
            setSnackBarMsg({
              message: "Please fill valid input.",
              severity: "error",
              open: true,
            });
            return
          } else {

            setInputData((prevState) => ({
              ...prevState,
              [name]: value
            }));
          }
        } else {
          setInputData((prevState) => ({
            ...prevState,
            [name]: value
          }));
        }

      }
    } else {
      setInputData((prevState) => ({
        ...prevState,
        [name]: value
      }));
    }
  }

  async function handleUpdate(e) {
    e.preventDefault();
    if (!phoneValid) {
      setSnackBarMsg({
        message: "Invalid Phone Number",
        severity: "error",
        open: true
      })
      return
    }

    
    // if (!/^\d{6}$/.test(inputData.zipcode)) {
    //   setSnackBarMsg({
    //     message: "Please enter valid zipcode.",
    //     severity: "error",
    //     open: true,
    //   });
    //   return
    const isValidZipCode = (zipcode) => {
      // Regex for US ZIP code (5-digit or 9-digit with optional hyphen)
      const usZipCodePattern = /^\d{5}(-\d{4})?$/;
      
      // Regex for Canadian postal codes (e.g., A1A 1A1)
      const canadianPostalCodePattern = /^[A-Za-z]\d[A-Za-z] \d[A-Za-z]\d$/;
    
      // Regex for UK postcodes (e.g., SW1A 1AA)
      const ukPostcodePattern = /^[A-Z]{1,2}\d[A-Z\d]? \d[A-Z]{2}$/;
    
      // Regex for Australian postcodes (4 digits)
      const australianPostcodePattern = /^\d{4}$/;
    
      // Regex for Indian PIN codes (6 digits)
      const indianPinCodePattern = /^\d{6}$/;
    
      return (
        usZipCodePattern.test(zipcode) ||
        canadianPostalCodePattern.test(zipcode) ||
        ukPostcodePattern.test(zipcode) ||
        australianPostcodePattern.test(zipcode) ||
        indianPinCodePattern.test(zipcode)
      );
    };
    
    // Usage in your code
    if (!isValidZipCode(inputData.zipcode)) {
      setSnackBarMsg({
        message: "Please enter a valid zipcode.",
        severity: "error",
        open: true,
      });
      return;
    }
    

    if (!/^(?:https?:\/\/)?(?:www\.)?linkedin\.com\/(in|pub|public-profile\/in|public-profile\/pub)\/([a-zA-Z0-9\-_]+)(?:\/[a-zA-Z0-9\-_]+)*\??(?:[^\s]+=[^\s&]+&?)*$/.test(inputData.link))  {
      setSnackBarMsg({
        message: "Please enter valid linkedin profile URL.",
        severity: "error",
        open: true,
      });
      return;
    }

    if (!inputData.firstName || !inputData.lastName || !inputData.email || !inputData.phone || !inputData.apartmentOrStreet
      || !inputData.city || !inputData.state || !inputData.zipcode || !inputData.occupation ||
      !inputData.country || !inputData.link) {
      setSnackBarMsg({
        message: "Please fill all the fields",
        severity: "error",
        open: true
      })
      return
    }

    try {
      const data = { updateObject: { ...inputData } };
      const response = await callApi(
        "put",
        "investor/updateinvestor",
        data,
        { "content-type": "application/json" },
        true,
        false
      );
      if (response.data.response.status) {
        setSnackBarMsg({
          message: "Details Edit Successfully",
          severity: "success",
          open: true,
        });
        setselected(1);
      } else {
        setSnackBarMsg({
          message: "Some error occur",
          severity: "error",
          open: true,
        });
      }
    } catch {
      setSnackBarMsg({
        message: "Some error occur",
        severity: "error",
        open: true,
      });
    }
  }

  async function HandleEdit() {
    setselected(0);
  }

  async function handleGet() {
    try {
      const response = await callApi("get", "investor/getinvestor");
      const data = response.data.data;
      localStorage.setItem('AllData', JSON.stringify(data))
      if (response.data.data) {
        setInputData(response.data.data);
        setInputData((prevState) => ({
          ...prevState,
          link: response.data.data.userDocuments[0].link,
        }));

        // setSnackBarMsg({
        //   message: "Data Get Successfully",
        //   severity: "success",
        //   open: true,
        // });
      } else {
        setSnackBarMsg({
          message: "Some error occur",
          severity: "error",
          open: true,
        });
      }
    } catch {
      setSnackBarMsg({
        message: "Some error occur",
        severity: "error",
        open: true,
      });
    }
  }

  async function getAllCountries() {
    const response = await callApi("get", "country/getCountry?step=1");
    setCountries(response.data.data);
  }

  async function ShowData() {
    const name = `${inputData.firstName} ${inputData.middleName} ${inputData.lastName}`;
    const newName = `${inputData.firstName} ${inputData.lastName}`;
    const addressParts = [
      inputData.apartmentOrStreet,
      inputData.city,
      inputData.state,
      inputData.zipcode,
    ];
    const validAddressParts = addressParts.filter(
      (part) => part !== null && part !== undefined
    );
    const address = validAddressParts.join(" ");
    setNewData((prevState) => ({
      ...prevState,
      name: name,
      address: address,
    }));
    setText(newName);
  }
  React.useEffect(() => {
    getAllCountries()
    handleGet();
  }, []);

  React.useEffect(() => {
    ShowData();
  }, [inputData]);

  React.useEffect(() => {
    const isFormComplete = Object.values(inputData).every(
      (value) => value !== ""
    );
    setFormComplete(isFormComplete);
  }, [inputData]);

  return (
    <>
      <div className="col-lg-12 col-md-12 col-sm-12 col-12 marginTop">
        <h2>General Detail</h2>

        {selected === 1 ? (
          <div className="general-detail-box investorformpage">
            <div className="row">
              <div className="col-md-4 col-12">
                <div className="ltdetail">
                  <p>Name</p>
                </div>
              </div>
              <div className="col-8">
                <div className="rtdetail">
                  <p>{inputData.firstName} {inputData.lastName}</p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 col-12">
                <div className="ltdetail">
                  <p>Email</p>
                </div>
              </div>
              <div className="col-8">
                <div className="rtdetail">
                  <p>{inputData.email}</p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 col-12">
                <div className="ltdetail">
                  <p>Contact</p>
                </div>
              </div>
              <div className="col-8">
                <div className="rtdetail">
                  <p>{inputData.phone}</p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 col-12">
                <div className="ltdetail">
                  <p>Address</p>
                </div>
              </div>
              <div className="col-8">
                <div className="rtdetail">
                  <p>{newData.address}</p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 col-12">
                <div className="ltdetail">
                  <p>Occupation</p>
                </div>
              </div>
              <div className="col-8">
                <div className="rtdetail">
                  <p>{inputData.occupation}</p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 col-12">
                <div className="ltdetail">
                  <p>Country of Citizenship</p>
                </div>
              </div>
              <div className="col-8">
                <div className="rtdetail">
                  <p>{inputData.country}</p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 col-12">
                <div className="ltdetail">
                  <p>LinkedIn Profile URL</p>
                </div>
              </div>
              <div className="col-8">
                <div className="rtdetail">
                  <p>{inputData.link}</p>
                </div>
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-12">
                <a style={{ cursor: "pointer", fontWeight: "500" }}
                  className="commanbutton commanbuttonprofile d-block text-center"
                  onClick={HandleEdit}
                >
                  Edit
                </a>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div class="general-detail-box ">
              <div class="investorform investorformpage">
                <form>
                  <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-4 col-12 text-white">
                      <div class="mb-3">
                        <label class="form-label text-white-50">
                          First Name<span>*</span>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          name="firstName"
                          value={inputData.firstName}
                          onChange={handleInputChange}
                          placeholder="Enter First Name"
                        />
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4 col-12 text-white">
                      <div class="mb-3">
                        <label class="form-label text-white-50">Middle Name</label>
                        <input
                          type="text"
                          class="form-control"
                          name="middleName"
                          value={inputData.middleName}
                          onChange={handleInputChange}
                          placeholder="Enter Middle Name"
                        />
                      </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4 col-12 text-white">
                      <div class="mb-3">
                        <label class="form-label text-white-50">
                          Last Name<span>*</span>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          name="lastName"
                          value={inputData.lastName}
                          onChange={handleInputChange}
                          placeholder="Enter Last Name"
                        />
                      </div>
                    </div>

                    <div class="col-lg-12 col-md-12 col-sm-12 col-12 text-white">
                      <div class="mb-3">
                        <label class="form-label text-white-50">
                          Email Id<span>*</span>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          name="email"
                          value={inputData.email}
                          placeholder="Enter Email"
                        />
                      </div>
                    </div>

                    <div class="col-lg-12 col-md-12 col-sm-12 col-12 text-white">
                      <div class="mb-3">
                        <label class="form-label text-white-50">
                          Contact<span>*</span>
                        </label>
                        {/* {countries.map((option, index) => {
                          return (
                            <MenuItem key={index} value={option.phonecode}>
                              {option.phonecode} {option.flag}
                            </MenuItem>
                          );
                        })} */}
                        <div className="d-flex" style={{ background: 'none' }}>
                          {/* <Select
                            className="form-control p-2 "
                            style={{ backgroundColor: "#121212", border: "1px #575555 solid", borderRadius: "8px 0px 0px 8px", color: "#fff", fontSize: "14px", height: "40px", flexShrink: "5" }}
                            id="country-code"
                            name="countryCode"
                            value={inputData.countryCode}
                            IconComponent={KeyboardArrowDownIcon}
                            onChange={handleInputChange}
                          >
                          </Select> */}
                          <PhoneInput
                            onBlur={phoneInput}
                            className="form-control phone-input1 myPhoneInput"
                            style={{ backgroundColor: "#000 !important", border: "none", padding: "0" }}
                            defaultCountry="IN"
                            countryCodes={true}
                            type="text"
                            // data-numeric
                            name="phone"
                            value={inputData.phone}
                            onChange={handlePhoneNumberChange}
                            placeholder="Enter Contact Number"

                          />
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-6 col-md-6 col-sm-6 col-12 text-white">
                      <div class="mb-3">
                        <label class="form-label text-white-50">
                          Apartment/Street Name<span>*</span>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          name="apartmentOrStreet"
                          value={inputData.apartmentOrStreet}
                          onChange={handleInputChange}
                          placeholder="Enter Appartment/Street"
                        />
                      </div>
                    </div>

                    <div class="col-lg-6 col-md-6 col-sm-6 col-12 text-white">
                      <div class="mb-3">
                        <label class="form-label text-white-50">
                          City<span>*</span>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          name="city"
                          value={inputData.city}
                          onChange={handleInputChange}
                          placeholder="Enter City "
                        />
                      </div>
                    </div>

                    <div class="col-lg-6 col-md-6 col-sm-6 col-12 text-white">
                      <div class="mb-3">
                        <label class="form-label text-white-50">
                          State<span>*</span>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          name="state"
                          value={inputData.state}
                          onChange={handleInputChange}
                          placeholder="Enter State"
                        />
                      </div>
                    </div>

                    <div class="col-lg-6 col-md-6 col-sm-6 col-12 text-white">
                      <div class="mb-3">
                        <label class="form-label text-white-50">
                          Zipcode<span>*</span>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          name="zipcode"
                          data-numeric
                          value={inputData.zipcode}
                          onChange={handleInputChange}
                          placeholder="Enter Zip Code"
                        />
                      </div>
                    </div>

                    <div class="col-lg-12 col-md-12 col-sm-12 col-12 text-white">
                      <div class="mb-3">
                        <label class="form-label text-white-50">
                          Occupation<span>*</span>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          name="occupation"
                          value={inputData.occupation}
                          onChange={handleInputChange}
                          placeholder="Enter Occupation"
                        />
                      </div>
                    </div>

                    <div class="col-lg-12 col-md-12 col-sm-12 col-12 text-white">
                      <div class="mb-3">
                        <label class="form-label text-white-50">
                          Country of Citizenship<span>*</span>
                        </label>
                        {/* <input
                          type="text"
                          class="form-control"
                          name="country"
                          value={inputData.country}
                          onChange={handleInputChange}
                          placeholder="Enter Country Name"
                        /> */}
                        <Select
                          className="form-control"
                          style={{ backgroundColor: "#121212", border: "1px #575555 solid", borderRadius: "8px", color: "#fff", fontSize: "14px", height: "40px" }}
                          id="country-citizen"
                          name="country"
                          value={inputData.country}
                          placeholder="Select country origin"
                          IconComponent={KeyboardArrowDownIcon}
                          onChange={handleInputChange}
                        >
                          {countries.map((option, index) => {
                            return (
                              <MenuItem key={index} value={option.name}>
                                {option.name}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </div>
                    </div>

                    <div class="col-lg-12 col-md-12 col-sm-12 col-12 text-white">
                      <div class="mb-3">
                        <label class="form-label text-white-50">
                          linkedin Profile URL<span>*</span>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          name="link"
                          value={inputData.link}
                          onChange={handleInputChange}
                          placeholder="Enter LinkedIn"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12 col-12 mt-4">
                    <button
                      type="submit"
                      class="btn d-block w-100 btn-primary"
                      onClick={handleUpdate}
                    >
                      Update
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </>
        )}
      </div>
      <CustomizedSnackbars msgData={snackBarMsg} setMsgData={setSnackBarMsg} />
    </>
  );
}
